// src/pages/Employment/ViewApplications.jsx
import React from 'react';
import { 
  FaUser, 
  FaEnvelope, 
  FaPhone, 
  FaBriefcase,
  FaClock,
  FaDownload,
  FaCheckCircle,
  FaTimes,
  FaSpinner,
} from 'react-icons/fa';
import { useGetJobApplicationsQuery } from '../../redux/services/employmentService/employment.Services';

function ViewApplications({ data }) {
  const { data: applicationsData, isLoading, isError, refetch } = useGetJobApplicationsQuery(data?.job_id);

  const applications = applicationsData?.data || [];

  const getStatusBadge = (status) => {
    const statusMap = {
      'pending': { class: 'badge bg-warning text-dark', label: 'Pending' },
      'shortlisted': { class: 'badge bg-info text-white', label: 'Shortlisted' },
      'interview': { class: 'badge bg-primary text-white', label: 'Interview' },
      'rejected': { class: 'badge bg-danger text-white', label: 'Rejected' },
      'hired': { class: 'badge bg-success text-white', label: 'Hired' },
    };
    const statusInfo = statusMap[status] || statusMap['pending'];
    return <span className={statusInfo.class}>{statusInfo.label}</span>;
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (isLoading) {
    return (
      <div className="text-center py-4">
        <FaSpinner className="spinning" size={30} />
        <p className="mt-2">Loading applications...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center py-4 text-danger">
        <p>Failed to load applications</p>
        <button className="btn btn-primary btn-sm" onClick={() => refetch()}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="view-applications-container">
      <div className="mb-3">
        <h5 className="fw-bold">{data?.title}</h5>
        <p className="text-muted">
          <FaBriefcase className="me-1" />
          Total Applications: <strong>{applications.length}</strong>
        </p>
      </div>

      {applications.length === 0 ? (
        <div className="text-center py-4">
          <FaUser size={40} className="text-muted" />
          <p className="mt-2 text-muted">No applications yet</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Experience</th>
                <th>Current Company</th>
                <th>Status</th>
                <th>Applied</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app, index) => (
                <tr key={app.id}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="fw-semibold">{app.full_name}</div>
                    {app.resume_path && (
                      <a 
                        href={app.resume_path} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-primary small d-block"
                      >
                        <FaDownload className="me-1" /> Resume
                      </a>
                    )}
                  </td>
                  <td>{app.email}</td>
                  <td>{app.phone}</td>
                  <td>{app.experience_years || 'N/A'}</td>
                  <td>
                    {app.current_company && (
                      <div>
                        <div>{app.current_company}</div>
                        {app.current_designation && (
                          <small className="text-muted">{app.current_designation}</small>
                        )}
                      </div>
                    )}
                    {!app.current_company && 'N/A'}
                  </td>
                  <td>{getStatusBadge(app.application_status)}</td>
                  <td>{formatDate(app.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ViewApplications;